/** Sample-data helpers for onboarding metadata step (JSON upload / paste). */

export const SAMPLE_JSON_MAX_BYTES = 2 * 1024 * 1024;

/** Parses sample JSON. Root must be a single plain object (not an array). */
export function parseSampleDataJsonFile(text: string): Record<string, unknown> {
  const parsed: unknown = JSON.parse(text);
  if (
    parsed === null ||
    typeof parsed !== 'object' ||
    Array.isArray(parsed)
  ) {
    throw new Error('Sample data JSON must be a single object');
  }
  return parsed as Record<string, unknown>;
}

export function formatSampleDataJson(value: unknown): string {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function utf8ByteLength(text: string): number {
  return new TextEncoder().encode(text).length;
}
